module.exports = __webpack_public_path__ + "src/assets/textures/spectro/spectro_graph.png";